// Report rows link into the practice portal (/portal/...). When the report is opened from the
// admin practice viewport, the same pages live under /admin/practices/:id/..., so rewrite the
// prefix to stay inside the viewport instead of bouncing to a route the admin cannot open.
const ADMIN_VIEWPORT_PREFIX = /^\/admin\/practices\/\d+/;

export const resolveViewportHref = (href, pathname = window.location.pathname) => {
  if (!href || typeof href !== 'string') return href;
  const viewport = pathname.match(ADMIN_VIEWPORT_PREFIX)?.[0];
  if (!viewport) return href;
  return href.startsWith('/portal/') ? href.replace(/^\/portal/, viewport) : href;
};
